import * as React from "react";
import Box from "@mui/material/Box";
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import ModeIcon from '@mui/icons-material/Mode';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LogoutIcon from '@mui/icons-material/Logout';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridToolbar,
  GridActionsCellItem,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
  GridToolbarDensitySelector,
  useGridApiContext,
  gridExpandedSortedRowIdsSelector
} from "@mui/x-data-grid";
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Stack, Avatar, Typography, Modal, Button, TextField } from "@mui/material";
import getAccess from "../../../utils/getAccess";
import { RHFTextField } from "../../../components/hook-form";
import axios from "axios";
import { useTheme } from '@emotion/react';
import LockResetIcon from "@mui/icons-material/LockReset";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useForm } from "react-hook-form";



const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  p: 4,
  borderRadius: '15px'
};


function CustomToolbar(props) {
  const { rows, columns } = props;
  const apiRef = useGridApiContext();
  const exportAllRows = async () => {
    const visibleRows = gridExpandedSortedRowIdsSelector(apiRef);
    const filteredRows = rows.filter((row) => visibleRows.includes(row.id));
    const columnIds = columns.filter((column) => column.field !== 'actions').map((column) => column.field);
    const csvHeader = columnIds.join(', ');
    const csvContent = filteredRows
      .map((row, index) => {
        const rowValues = columnIds.map((columnId) => {
          if (columnId === 'serialNumber') {
            return index + 1;
          } else if (columnId === 'profileWithName') {
            return row[columnId]?.name;
          }

          return row[columnId]?.toString().replaceAll(",", " ");
        });
        return rowValues.join(', ');
      })
      .join('\n');
    const fullCsvContent = `${csvHeader}\n${csvContent}`;
    const blob = new Blob([fullCsvContent], { type: `text/csv;charset=utf-8` });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', 'AllStaff.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />

      <GridToolbarDensitySelector />
      <Tooltip title="Export All">
        <IconButton onClick={exportAllRows}>
          <SaveAltIcon style={{ color: 'red' }} />
        </IconButton>
      </Tooltip>
      <GridToolbarQuickFilter />
    </GridToolbarContainer>
  );
};

export default function TeacherGrid() {
  const [rows, setRows] = React.useState([]);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const theme = useTheme()

  const [loading, setLoading] = React.useState(true);
  const navigate = useNavigate();
  const access = getAccess();
  const [rowCount, setRowCount] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25,
  });
  const [searchText, setSearchText] = React.useState("");
  const [filterModel, setFilterModel] = React.useState({
    items: [],
    quickFilterValues: [],
  });

  // modal  
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  }
  const [id, setId] = React.useState("");
  const [file, setFile] = React.useState();
  const [val, setVal] = React.useState(false);
  const [focused, setFocused] = React.useState(false);

  const changeHandler = (e) => {
    setFile(e.target.files[0])
  }

  const profileUpdate = async () => {
    if (file) {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", file);
      formData.append("teacher", id);
      const token = localStorage.getItem("token");
      const authToken = token;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      };
      axios
        .put(
          `${process.env.REACT_APP_LIVE_URL}/adminSection/updateProfilePhoto`,
          formData,
          config
        )
        .then((response) => {
          if (response.data.status) {
            setLoading(false);
            toast.success("Profile Update Successfully");
            handleClose();
            // setTimeout(() => {
            //   // navigate(`/dashboard/batchDetails/${Id}`);
            // }, 1000);
          } else {
            toast.error(response.data.msg);
            // reset();
            setLoading(false);
          }
        })
        .catch((e) => {
          //console.log(e);
        });
    } else {
      toast.error('Please Select A Profile Photo')

    }

  };

  const fetchTeachers = async () => {
    const token = localStorage.getItem("token");
    setLoading(true);

    const res = await fetch(
      `${process.env.REACT_APP_LIVE_URL}/adminTeacher/getteacherListByAdmin` +
      `?page=${paginationModel.page}` +
      `&pageSize=${paginationModel.pageSize}` +
      `&searchText=${encodeURIComponent(searchText)}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const json = await res.json();
    const data = json.data || [];

    const withMeta = data.map((r, i) => ({
      ...r,
      id: r._id || r.id,
      sNo: paginationModel.page * paginationModel.pageSize + i + 1,
    }));

    setRows(withMeta);
    setRowCount(json.pagination?.totalCount || json.count || 0);
    setLoading(false);
  };

  React.useEffect(() => {
    fetchTeachers();
  }, [paginationModel.page, paginationModel.pageSize, searchText]);

  React.useEffect(() => {
    const handler = (e) => {
      if (e.key !== "Enter") return;
      const el = document.activeElement;
      if (!el || el.tagName !== "INPUT") return;
      const value = el.value || "";
      if (el.closest(".MuiDataGrid-toolbarContainer")) {
        setSearchText(value);
        setFilterModel(prev => ({
          ...prev,
          quickFilterValues: [value],
        }));
        setPaginationModel(p => ({ ...p, page: 0 }));
      }
      if (el.closest('[class*="MuiDataGrid-filterForm"]')) {
        setSearchText(value);
        setPaginationModel(p => ({ ...p, page: 0 }));
      }
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, []);

  const makeActiveAndInActiveTeacher = async (id) => {
    const token = localStorage.getItem("token");
    const response = await fetch(`${process.env.REACT_APP_LIVE_URL}/adminTeacher/makeActiveAndInActiveTeacher/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },

    });
    const responseJson = await response.json();
    // console.log(responseJson);
    if (responseJson?.status) {
      toast.success(responseJson.msg)
      setTimeout(() => window.location.reload()
        , 1000)
    } else {
      toast.error(responseJson.msg);
    }
    // setLoadingButton(false)
    // toast.success('Deleted')


  }

  const logoutUser = async (id) => {
    const token = localStorage.getItem("token");
    const response = await fetch(`${process.env.REACT_APP_LIVE_URL}/adminPanel/logoutAdmin/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },

    });
    const responseJson = await response.json();
    // console.log(responseJson);
    if (responseJson?.status) {
      toast.success(responseJson.msg)
      setTimeout(() => window.location.reload()
        , 1000)
    } else {
      toast.error(responseJson.msg);
    }
    // setLoadingButton(false)
    // toast.success('Deleted')


  }
  // reset password modal
  const [resetOpen, setResetOpen] = React.useState(false);
  const [resetUserId, setResetUserId] = React.useState("");
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });

  const onResetPasswordSubmit = async (formData) => {
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(
        `${process.env.REACT_APP_LIVE_URL}/adminPanel/adminResetPassword`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            userId: resetUserId,
            password: formData.newPassword,
          }),
        }
      );

      const data = await response.json();

      if (data?.status) {
        toast.success("Password updated successfully");
        setResetOpen(false);
        reset();
      } else {
        toast.error(data?.msg || "Reset failed");
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };
  const handleResetClose = () => {
    setResetOpen(false);
    reset();
    setShowNewPassword(false);
    setShowConfirmPassword(false);
  };


  const handleSaveClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };
  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.id === id);
    if (editedRow.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };
  const columns = [
    {
      field: "sNo",
      headerName: "S NO",
      width: 75,
      align: "left",
      headerAlign: "left",
      // editable: false,
      renderCell: (params) => <strong>{params.value}</strong>,
    },

    {
      field: "profileWithName",
      headerName: "Name",
      type: "string",
      width: 250,
      align: "left",
      headerAlign: "left",
      // editable: true,
      renderCell: (params) => (
        <Stack direction="row" alignItems="center" spacing={2}>
          <Avatar alt={params?.value?.name} src={params?.value?.profilePhoto} sx={{ width: 28, height: 28 }} />
          <Typography variant="subtitle2" noWrap>{params?.value?.name}</Typography>
        </Stack>
      )
    },
    {
      field: "email",
      headerName: "Email",
      type: "string",
      width: 200,
      align: "left",
      headerAlign: "left",
      // editable: true,
      renderCell: (params) => (
        <div>{params.value ?? "NA"}</div>
      ),
    },
    {
      field: "mobileNumber",
      headerName: "Phone",
      type: "String",
      width: 150,
      align: "left",
      headerAlign: "left",
      // editable: true,
    },
    {
      field: "Role",
      headerName: "Role",
      type: "String",
      width: 150,
      align: "left",
      headerAlign: "left",
      // editable: true,
    },
    {
      field: "categories",
      headerName: "Categories",
      type: "String",
      width: 150,
      align: "left",
      headerAlign: "left",
      // editable: true,
      renderCell: (params) => (
        params?.value?.length > 0 ? <Stack spacing={2} direction='column' >
          {params?.value?.map((item) => (
            <span>{item?.title}</span>
          ))}
        </Stack> : <strong>NA</strong>

      )
    },
    {
      field: "demoVideo",
      headerName: "Demo Video",
      type: "String",
      width: 150,
      align: "left",
      headerAlign: "left",
      // editable: true,
      renderCell: (params) => (
        params.value != "" ? <a
          href={params.value}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <YouTubeIcon fontSize="large" style={{ color: 'red', marginRight: '8px' }} />
        </a> : <span>NA</span>
      )
    },


    {
      field: "created_at",
      headerName: "Created At",
      type: "String",
      width: 250,
      align: "left",
      headerAlign: "left",
      // editable: true,
    },
    {
      field: "isActive",
      headerName: "Status",
      type: "boolean",
      width: 100,
      align: "left",
      headerAlign: "left",
      // editable: true,
      renderCell: (params) => (
        <div style={{ color: params.value == true ? "green" : "red" }}>
          {params.value ? "Active" : "inActive"}
        </div>
      ),
    },
    {
      field: "refreshToken",
      headerName: "isLogin",
      type: "string",
      width: 100,
      align: "left",
      headerAlign: "left",
      // editable: true,
      renderCell: (params) => (
        <div style={{ color: params?.value == "" ? "red" : "green" }}>
          {params?.value == "" ? "Not Login" : "Login"}
        </div>
      ),
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 150,
      cellClassName: "actions",
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
        const rowData = rows.find(item => item.id === id);
        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{
                color: "primary.main",
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }

        return [
          ((access?.accessForTab == 'readWrite' || access?.access.includes('all')) ? <Tooltip title="Edit">
            <GridActionsCellItem
              icon={<ModeIcon />}
              label="Edit"
              onClick={() => navigate(`/dashboard/staff/updateStaff/${id}`)}
              color="inherit"
            />
          </Tooltip> : <></>)
          ,
          ((access?.accessForTab == 'readWrite' || access?.access.includes('all')) ? <Tooltip title="Update Permission">
            <GridActionsCellItem
              icon={<LockPersonIcon sx={{ color: 'red' }} />}
              label="Update Permission"
              onClick={() => navigate(`/dashboard/staff/updatePermission/${id}`)}
              color="inherit"
            />
          </Tooltip> : <></>),
          ((access?.accessForTab == 'readWrite' || access?.access.includes('all')) ? <Tooltip title="Change Status">
            <GridActionsCellItem
              icon={rowData?.isActive ? <ToggleOffIcon style={{ color: 'green' }} /> : <ToggleOnIcon style={{ color: 'red' }} />}
              label="Status"
              onClick={() => { makeActiveAndInActiveTeacher(id) }}
              color="inherit"
            />
          </Tooltip> : <></>),

          ((access?.accessForTab == 'readWrite' || access?.access.includes('all')) ? <Tooltip title="Logout">
            <GridActionsCellItem
              icon={<LogoutIcon style={{ color: 'red' }} />}
              label="Status"
              onClick={() => { logoutUser(id) }}
              color="inherit"
            />
          </Tooltip> : <></>)
          ,
          ((access?.accessForTab === 'readWrite' || access?.access.includes('all')) ? (
            <Tooltip title="Reset Password">
              <GridActionsCellItem
                icon={<LockResetIcon sx={{ color: "orange" }} />}
                label="Reset Password"
                onClick={() => {
                  setResetUserId(id);
                  setResetOpen(true);
                }}
                color="inherit"
              />
            </Tooltip>
          ) : <></>),
          ((access?.accessForTab == 'readWrite' || access?.access.includes('all')) ? <Tooltip title="Profile Update">
            <GridActionsCellItem
              icon={<InsertEmoticonIcon style={{ color: 'red' }} />}
              label="Update Profile"
              onClick={() => { setId(id); setOpen(true) }}
              color="inherit"
            />
          </Tooltip> : <></>)
        ];
      },
    },
  ];



  return (
    <Box
      sx={{
        height: 500,
        width: "100%",
        "& .actions": {
          color: "text.secondary",
        },
        "& .textPrimary": {
          color: "text.primary",
        },
      }}
    >
      <Box mb={2}>
        {/* <h2>All Staff</h2> */}
      </Box>
      <DataGrid
        getRowHeight={() => 'auto'}
        rows={rows}
        columns={columns}
        loading={loading}

        paginationMode="server"
        filterMode="server"
        rowCount={rowCount}

        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}

        filterModel={filterModel}
        onFilterModelChange={setFilterModel}

        editMode="row"
        rowModesModel={rowModesModel}
        onRowModesModelChange={handleRowModesModelChange}
        processRowUpdate={processRowUpdate}

        pageSizeOptions={[25, 50, 100]}

        slots={{
          toolbar: CustomToolbar,
        }}
        slotProps={{
          toolbar: {
            rows,
            columns,
            showQuickFilter: true,
          },
        }}
      />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="profile-update"
        aria-describedby="for-profile-update-of-staff"
      >
        <Box sx={style}>
          <Box sx={{ marginBottom: '10px' }}>
            <h3>Upload Profile Photo </h3>
          </Box>
          <TextField
            name="file"
            onChange={changeHandler}
            id="file"
            error={!file && val}
            helperText='Image Only ( Maximum allowed size 100KB)'
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            InputProps={{
              classes: {
                input: "CustomTextField"
              }
            }}
            inputProps={{ accept: "image/*" }}
            type='file'
          />
          <Stack direction='row' spacing={2} m={3} align='center' justifyContent="space-evenly">
            <Button variant="contained" style={{ backgroundColor: theme.palette.primary.mainTheme, color: 'white', "&:hover": { background: "red" } }} onClick={() => handleClose()}>Cancel</Button>
            <Button variant="contained" style={{ backgroundColor: theme.palette.primary.mainTheme, color: 'white', "&:hover": { background: "red" } }} onClick={() => profileUpdate()}>Upload</Button>
          </Stack>
        </Box>

      </Modal>
      <Modal open={resetOpen} onClose={handleResetClose}>
        <Box sx={style}>
          <Typography
            variant="h5"
            sx={{ fontWeight: 600, color: "#8B5CF6", mb: 2 }}
          >
            Reset Password
          </Typography>

          <form onSubmit={handleSubmit(onResetPasswordSubmit)}>
            {/* New Password */}
            <TextField
              label="New Password"
              type={showNewPassword ? "text" : "password"}
              fullWidth
              margin="normal"
              error={!!errors.newPassword}
              helperText={
                errors.newPassword?.message ||
                "First letter capital, 8–15 characters"
              }
              {...register("newPassword", {
                required: "New password is required",
                minLength: {
                  value: 8,
                  message: "Minimum 8 characters",
                },
                maxLength: {
                  value: 15,
                  message: "Maximum 15 characters",
                },
                pattern: {
                  value: /^[A-Z].*/,
                  message: "First letter must be capital",
                },
              })}
              InputProps={{
                endAdornment: (
                  <IconButton
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    edge="end"
                  >
                    {showNewPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                ),
              }}
              sx={{
                "& label.Mui-focused": { color: "#8B5CF6" },
                "& .MuiOutlinedInput-root.Mui-focused fieldset": {
                  borderColor: "#8B5CF6",
                },
              }}
            />

            {/* Confirm Password */}
            <TextField
              label="Confirm Password"
              type={showConfirmPassword ? "text" : "password"}
              fullWidth
              margin="normal"
              error={!!errors.confirmPassword}
              helperText={errors.confirmPassword?.message}
              {...register("confirmPassword", {
                required: "Confirm password is required",
                validate: (value) =>
                  value === watch("newPassword") ||
                  "Passwords do not match",
              })}
              InputProps={{
                endAdornment: (
                  <IconButton
                    onClick={() =>
                      setShowConfirmPassword(!showConfirmPassword)
                    }
                    edge="end"
                  >
                    {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                ),
              }}
              sx={{
                "& label.Mui-focused": { color: "#8B5CF6" },
                "& .MuiOutlinedInput-root.Mui-focused fieldset": {
                  borderColor: "#8B5CF6",
                },
              }}
            />

            {/* Buttons */}
            <Stack direction="row" spacing={2} mt={3} justifyContent="flex-end">
              <Button
                variant="outlined"
                sx={{
                  color: "#8B5CF6",
                  borderColor: "#8B5CF6",
                }}
                onClick={handleResetClose}
              >
                Cancel
              </Button>

              <Button
                type="submit"
                variant="contained"
                sx={{
                  backgroundColor: "#8B5CF6",
                  px: 4,
                  "&:hover": { backgroundColor: "#7C3AED" },
                }}
              >
                Update Passwordw
              </Button>
            </Stack>
          </form>
        </Box>
      </Modal>

      <ToastContainer
        position="bottom-center"
        autoClose={1000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Box>
  );
}
